import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import GradientCard from "./GradientCard";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const GradientCardSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Row className={"justify-content-center "}>
      <Col xs={12} xl={11} xxl={10} className={"mt-5"}>
        <Row className={"justify-content-center"}>
          <Col xs={12} lg={3} style={{ maxWidth: "400px", minHeight: "330px" }} className={"my-3"}>
            <GradientCard
              hasImage={true}
              imageSrc={"/LandingPageImages/officeDeskSpace.webp"}
              header={t("landing.home.cards.talentAnalytics.title")}
              contentList={[
                t("landing.home.cards.talentAnalytics.item1"),
                t("landing.home.cards.talentAnalytics.item2"),
                t("landing.home.cards.talentAnalytics.item3"),
                t("landing.home.cards.talentAnalytics.item4"),
                t("landing.home.cards.talentAnalytics.item5"),
                t("landing.home.cards.talentAnalytics.item6"),
              ]}
              onClick={() => {
                navigate("/skillAnalytics");
              }}
            ></GradientCard>
          </Col>
          <Col xs={12} lg={3} style={{ maxWidth: "400px", minHeight: "330px" }} className={"my-3"}>
            <GradientCard
              header={t("landing.home.cards.talentManagement.title")}
              imageSrc={"/LandingPageImages/transparentStatisticsV2.webp"}
              hasBottomImage={true}
              contentList={[
                t("landing.home.cards.talentManagement.item1"),
                t("landing.home.cards.talentManagement.item2"),
                t("landing.home.cards.talentManagement.item3"),
              ]}
              onClick={() => {
                navigate("/individualServices");
              }}
            ></GradientCard>
          </Col>

          <Col xs={12} lg={3} style={{ maxWidth: "400px", minHeight: "330px" }} className={"my-3"}>
            <GradientCard
              header={t("landing.home.cards.careerAnalytics.title")}
              hasBottomImage={true}
              imageSrc={"/LandingPageImages/transparentStatistics.webp"}
              contentList={[
                t("landing.home.cards.careerAnalytics.item1"),
                t("landing.home.cards.careerAnalytics.item2"),
                t("landing.home.cards.careerAnalytics.item3"),
              ]}
              onClick={() => {
                navigate("/individualServices");
              }}
            ></GradientCard>
          </Col>

          <Col xs={12} lg={3} style={{ maxWidth: "400px", minHeight: "330px" }} className={"my-3"}>
            <GradientCard
              header={t("landing.home.cards.careerManagement.title")}
              imageSrc={"/LandingPageImages/chessBoard.webp"}
              hasImage={true}
              contentList={[
                t("landing.home.cards.careerManagement.item1"),
                t("landing.home.cards.careerManagement.item2"),
              ]}
              onClick={() => {
                navigate("/individualServices");
              }}
            ></GradientCard>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default GradientCardSection;
